import { render } from "./AddUserToClinicForm.vue?vue&type=template&id=ac0df488&scoped=true"
import script from "./AddUserToClinicForm.vue?vue&type=script&lang=js"
export * from "./AddUserToClinicForm.vue?vue&type=script&lang=js"

import "./AddUserToClinicForm.vue?vue&type=style&index=0&id=ac0df488&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac0df488"]])

export default __exports__